import styled, { css } from 'styled-components';
import is, { isNot } from 'styled-is';

import { Flex, gridSizes, media, zIndexses } from 'utils/style';

import ResponsiveModal from 'components/ResponsiveModal/container';

const commonStyles = css`
  position: absolute;
  z-index: ${zIndexses.responsiveModal};
  background: #fff;
  ${Flex.column};
`;

const mobileStyles = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;

  .header {
    flex: 0;
    ${Flex.row};
    padding: 0 ${gridSizes('M')};
    align-items: center;
    border-bottom: 1px solid var(--grey-mouse);
    height: 56px;
    min-height: 56px;
  }

  .content {
    flex: 1;
    overflow: hidden;
    overflow-y: auto;
  }

  .footer {
    flex: 0;
    border-top: 1px solid var(--grey-mouse);
  }
`;

const desktopStyles = css`
  top: calc(100% + 5px);
  bottom: auto;
  right: auto;
  ${(props) =>
    !!props.alignRight &&
    css`
      right: -6px;
    `}
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  border: 1px solid var(--grey-mouse);
  overflow: hidden;
  min-width: 180px;
  .header {
    display: none;
  }
  .footer {
    display: none;
  }
`;

export default styled(ResponsiveModal)`
  position: relative;

  width: 100%;

  .floating {
    ${commonStyles}
    ${desktopStyles}

    ${isNot('disableModalOnMobile')`
      ${media.lessThan('extraSmall')`
        ${mobileStyles}
      `}
    `}

    ${is('disableModalOnMobile')`
      ${desktopStyles}
    `}
  }
`;
